import {
  Paper,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import ClearIcon from '@mui/icons-material/Clear';
import { DebounceInput } from 'react-debounce-input';

const PREFIX = 'ContentSearch';

const classes = {
  search: `${PREFIX}-search`,
  searchNum: `${PREFIX}-searchNum`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`& .${classes.search}`]: {
    width: '100%',
  },

  [`& .${classes.searchNum}`]: {
    width: '100%',
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
  },
}));

interface ContentSearchProps {
  icon: React.ReactNode;
  placeholder?: string;
  currentSearchFilter?: string;
  type?: string;
  onSearchChange: (val: string) => void;
}

export default function ContentSearch({
  icon,
  placeholder,
  currentSearchFilter,
  type = 'text',
  onSearchChange,
}: ContentSearchProps) {
  const handleChange = (value: string) => {
    onSearchChange(value);
  };

  const clearSearch = () => {
    onSearchChange('');
  };

  return (
    <StyledPaper elevation={0}>
      <DebounceInput
        minLength={1}
        debounceTimeout={300}
        onChange={(evt) => handleChange(evt.target.value)}
        element={OutlinedInput}
        className={type === 'number' ? classes.searchNum : classes.search}
        placeholder={placeholder}
        value={currentSearchFilter}
        type={type}
        startAdornment={
          <InputAdornment position="start">{icon}</InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              data-testid="clear"
              disabled={!currentSearchFilter}
              onClick={clearSearch}
              size="large">
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        }
      />
    </StyledPaper>
  );
}
